import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
const tiers = [{
  name: 'Starter App',
  price: 'R10,000 – R25,000',
  description: 'Perfect for validating simple ideas and prototypes.',
  features: ['Rapid delivery', 'Core functionality', 'Basic UI/UX design', 'Deployment setup']
}, {
  name: 'Medium App',
  price: 'R25,000 – R75,000',
  description: 'Full-featured MVPs ready for market launch.',
  features: ['Custom design system', 'User authentication', 'Database integration', 'Admin dashboard', 'Payment processing'],
  highlight: true
}, {
  name: 'Advanced App Platforms',
  price: 'R75,000 – R250,000',
  description: 'Complex scalable platforms with specialized requirements.',
  features: ['Advanced architecture', 'Third-party integrations', 'Real-time features', 'Complex workflows', 'Scalable infrastructure']
}];
export function Pricing() {
  return <section className="w-full bg-neutral-50 py-24 md:py-32 border-t border-neutral-200" data-id="element-102">
      <div className="max-w-7xl mx-auto px-6" data-id="element-103">
        <div className="max-w-3xl mb-16" data-id="element-104">
          <FadeIn data-id="element-105">
            <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-neutral-900 mb-6" data-id="element-106">
              Pricing
            </h2>
            <p className="text-xl text-neutral-500 leading-relaxed" data-id="element-107">
              Each project is scoped individually based on requirements. We
              provide a detailed quote before work begins.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-108">
          {tiers.map((tier, index) => <FadeIn key={index} delay={index * 0.1} className="h-full" data-id="element-109">
              <div className={`h-full p-8 rounded-2xl border flex flex-col ${tier.highlight ? 'bg-white border-neutral-200 shadow-xl shadow-neutral-900/5 relative overflow-hidden' : 'bg-white border-neutral-100 shadow-sm'}`} data-id="element-110">

                {tier.highlight && <div className="absolute top-0 right-0 bg-neutral-900 text-white text-xs font-medium px-3 py-1 rounded-bl-lg" data-id="element-111">
                    Most Popular
                  </div>}

                <div className="mb-8" data-id="element-112">
                  <h3 className="text-lg font-medium text-neutral-900 mb-2" data-id="element-113">
                    {tier.name}
                  </h3>
                  <div className="text-2xl md:text-3xl font-bold text-neutral-900 tracking-tight mb-4" data-id="element-114">
                    {tier.price}
                  </div>
                  <p className="text-neutral-500 text-sm leading-relaxed" data-id="element-115">
                    {tier.description}
                  </p>
                </div>

                <ul className="space-y-4 mb-8 flex-1" data-id="element-116">
                  {tier.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-117">
                      <Check className="w-5 h-5 text-neutral-900 flex-shrink-0 mr-3" data-id="element-118" />
                      <span className="text-neutral-600 text-sm" data-id="element-119">
                        {feature}
                      </span>
                    </li>)}
                </ul>

                <Button href="https://tally.so/r/PdO4XV" variant={tier.highlight ? 'primary' : 'secondary'} className="w-full justify-center" data-id="element-120">

                  Get a Quote
                </Button>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} className="mt-16 text-center" data-id="element-121">
          <p className="text-neutral-500 text-sm md:text-base bg-white inline-block px-6 py-3 rounded-full border border-neutral-100 shadow-sm" data-id="element-122">
            Projects are delivered in{' '}
            <span className="font-medium text-neutral-900" data-id="element-123">
              milestone-based payments
            </span>{' '}
            to ensure quality and trust.
          </p>
        </FadeIn>
      </div>
    </section>;
}